<template>
  <div class="homePage">
    <SearchNav ref="search" @search="refreshList" />
    <div class="content">
      <Categories v-if="showNavList" :navList="navList" ref="categories" @change="linkTo" />
      <!-- 由于页面有不同的导航坑位,考虑到搜索的时候可能都会需要更新数据列表,需要在路由组件中统一提供getList方法-->
      <router-view @update-cart="$refs.search.updateCartNum()" ref="view" />
    </div>
    <!-- 资源弹窗 -->
    <template v-if="showPopup">
      <div class="popup-wrapper">
        <div class="popup">
          <img class="pointer" style="height: 100%; width: 100%" :src="frontPop.pic" @click="openPopup" />
          <i @click="showPopup = false" class="el-icon-close close pointer"></i>
        </div>
      </div>
      <div class="mask"></div>
    </template>
  </div>
</template>

<script>
import * as api from '@/services';
import SearchNav from '@/components/SearchNav';
import Categories from './components/Categories';

export default {
  components: {
    SearchNav,
    Categories
  },
  provide() {
    return {
      home: this
    };
  },
  data() {
    return {
      resourceList: [],
      showNavList: false,
      navList: [],
      showPopup: false,
      frontPop: {}
    };
  },
  methods: {
    init() {
      let length = this.resourceList.length;
      for (let i = 0; i < length; i++) {
        if (this.resourceList[i].resourceCode == 'BRS_NAVIGATION') {
          this.showNavList = true;
          this.navList = this.resourceList[i].navList;
        }
      }
    },
    refreshList() {
      // this.$refs.view.getList();
    },
    linkTo(route) {
      this.$router.push(route);
    },
    openPopup() {
      window.open(this.frontPop.ref, '_blank');
    },
    // 获取资源投放信息
    async getResourceList() {
      const { global, resources } = await api.homePage.getResourceList();

      this.resourceList = resources;

      this.init();
    },
    // 获取弹窗信息
    async getPopup() {
      let frontPop = await api.homePage.getPopupResource();
      this.frontPop = frontPop;

      let popupData = JSON.parse(window.localStorage.getItem('popupData')) || {};
      const nowTime = new Date().getTime();
      // 一个活动上次弹框超过一天或者从没展示过才展示
      if (frontPop && frontPop.resourceId) {
        if (
          (popupData[frontPop.resourceId] && nowTime - popupData[frontPop.resourceId] > 86400000) ||
          !popupData[frontPop.resourceId]
        ) {
          this.showPopup = true;
          popupData[frontPop.resourceId] = nowTime;
          window.localStorage.setItem('popupData', JSON.stringify(popupData));
        }
      }
    }
  },
  created() {
    this.getPopup();
    this.getResourceList();
  }
};
</script>

<style lang="scss" scoped>
.homePage {
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.65;
    background: #000;
    z-index: 2000;
  }
  .popup-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2001;
  }
  .popup {
    position: absolute;
    width: 600px;
    height: 450px;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    z-index: 100;
  }
  .close {
    position: absolute;
    top: -16px;
    color: #ffffff;
  }
}
</style>
